const STAGE_FRONTEND_HOST = 'stage.bitbothub.com';
const STAGE_API_ORIGIN = 'https://api-stage.bitbothub.com';

export const API_ORIGIN = (() => {
  if (typeof window === 'undefined') return '';
  const host = window.location.hostname.toLowerCase();
  if (host === STAGE_FRONTEND_HOST) {
    return STAGE_API_ORIGIN;
  }
  return '';
})();

export const API_BASE_URL = API_ORIGIN ? `${API_ORIGIN}/api` : '/api';
